import VoidItemDetailQueries from './VoidItemDetailQueries.js'

const voidedCartLineProperties = {
  voidedCartLineProperties: {
    ...VoidItemDetailQueries,
  }
}

export default voidedCartLineProperties